const SingleTerm = ({props}) => {
    return (
        <div className="col-lg-7 col-xl-6" style={{margin: "2em"}}>
            <h3>{props.title}</h3>
            <p>{props.text}</p>  
        </div>
    )
}

export default SingleTerm